/**
 * преобразует переданные аргументы в строку классов css
 *
 * @param args строки или массивы строк, которые необходимо преобразовать в строку
 *
 * @returns строку, содержащую переданные css классы перечисленные через пробел
 */
var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var res = args.reduce(function (acc, item) {
        var argType = typeof item;
        if (argType === 'string' || argType === 'number') {
            acc.push(item);
        }
        else if (Array.isArray(item)) {
            if (item.length) {
                var inner = classNames.apply(void 0, item);
                if (inner) {
                    acc.push(inner);
                }
            }
        }
        else if (argType === 'object' && item) {
            Object.entries(item).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value) {
                    acc.push(key);
                }
            });
        }
        return acc;
    }, []);
    return res.join(' ');
};

export { classNames };
